import { useScrollReveal } from '@/hooks/useScrollReveal';
import { whyChooseUs } from '@/mocks/stats';

export default function WhyChooseUs() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section className="w-full py-16 md:py-24 bg-ivory-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div
          ref={ref}
          className={`text-center mb-10 md:mb-14 ${isVisible ? 'animate-fade-in-up' : 'opacity-0'}`}
        >
          <span className="inline-block text-xs md:text-sm font-semibold text-brand-orange uppercase tracking-widest mb-3">
            Why Investors Trust Us
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-charcoal-300">
            Why Choose Sunshine Real Estate
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 max-w-6xl mx-auto">
          {whyChooseUs.map((item, index) => (
            <div
              key={item.id}
              className={`group bg-white p-6 md:p-8 rounded-2xl shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-500 border-t-4 border-transparent hover:border-brand-orange ${
                isVisible ? 'animate-fade-in-up' : 'opacity-0'
              }`}
              style={{ animationDelay: `${0.1 + index * 0.1}s` }}
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-brand-orange/10 text-brand-orange mb-4 group-hover:bg-brand-orange group-hover:text-white transition-colors duration-300">
                <i className={`${item.icon} text-2xl`} />
              </div>
              <h3 className="text-lg md:text-xl font-bold text-charcoal-300 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-charcoal-50 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}